import { API_URL } from "../Util/constant";
import { STORAGE_KEYS } from "../Util/key_helper";
import { logoutUser } from "../Util/helper_functions";
export async function makeGetApiRequest(path) {
	try {
		const response = await fetch(`${API_URL}${path}`, {
			headers: { Authorization: localStorage.getItem(STORAGE_KEYS.BROKER_PANEL_USER_ACCESS_TOKEN) },
		});
		if (response.status === 401) {
			logoutUser(undefined)
		}
		let ret_data = await response.json();
		return ret_data;
	} catch (error) {
		console.error(error);
		return {
			error: {
				title: "Api request error",
				message: "Api request error",
				error: error,
			},
		};
	}
}

export async function makeApiRequest(path, params, skipStringify = false) {
	try {
		var reqHeader = new Headers();
		reqHeader.append(
			"Authorization",
			localStorage.getItem(STORAGE_KEYS.BROKER_PANEL_USER_ACCESS_TOKEN)
		);
		reqHeader.append("Content-Type", "application/json");
		const response = await fetch(`${API_URL}${path}`, {
			method: "POST",
			body: skipStringify ? params : JSON.stringify(params),
			headers: reqHeader,
			// mode:'no-cors',
			redirect: "follow",
		});
		if (response.status === 401) {
			logoutUser(undefined)
		}
		const rresponse = await response.json();
		if (!rresponse.error) {
			return { result: rresponse };
		} else {
			return { error: rresponse.error.data };
		}
	} catch (error) {
		console.error(error);
		return {
			error: {
				title: "Api request error",
				message: "Api request error",
				error: error,
			},
		};
	}
}


// V4 -  USER LOGIN 
export async function UserLogin(Values) {
	const response = await makeApiRequest("/auth/brokerpaneluserlogin", Values);

	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
// V4 -  USER REGISTRATION
export async function UserRegistration(Values) {
	const response = await makeApiRequest("/auth/brokerpaneluserregister", Values);

	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
// V4 -  USER FORGOT PASSWORD
export async function UserForgotPassword(Values) {
	const response = await makeApiRequest("/auth/brokerpaneluserforgotpwd", Values);

	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}

//---------------------------------------------------PROFILE ------------------------------------------------
// V4 - GET PROFILE 
export async function GetUserProfile() {
	const response = await makeGetApiRequest("/brokerpanelusers/getprofile");
	if (response.data) {
		return response;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
//V4 - UPDATE PROFILE
export async function UpdateUserProfile(values) {
	const response = await makeApiRequest("/brokerpanelusers/updateprofile", values);

	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
// GET WALLET 
export async function GetWallet(values) {
	const response = await makeApiRequest("/brokerpanelusers/getledger", values);

	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
// GET ACTIVITY LOGS 
export async function GetActivityLogs(values) {
	const response = await makeApiRequest("/brokerpanelusers/getactivities", values);

	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}

// V4 -  RESET PASSSWORD
export async function ResetPassword(Values) {
	const response = await makeApiRequest("/brokerpanelusers/resetpassword", Values);

	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
//---------------------------------------------------STRATEGY ------------------------------------------------
// V4 - GET STRATEGY 
export async function GetStrategy(payload) {
	const response = await makeApiRequest("/brokerpanelusers/strategies/getstrategies", payload);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		console.log(response.error);
		return { status: false, msg: response.error.message };
	} else {
		return { status: false, msg: "Unknown error. Please try again." };
	}
}
//V4 - GET  STARTGEY BY ID 
export async function GetStrategyById(payload) {
	const response = await makeApiRequest("/brokerpanelusers/strategies/getstrategybyid", payload);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		console.log(response.error);
		return { status: false, msg: response.error.message };
	} else {
		return { status: false, msg: "Unknown error. Please try again." };
	}
}

//V4 - GET  STARTGEY PLAN
export async function GetStrategyPlan(payload) {
	const response = await makeApiRequest("/brokerpanelusers/strategies/getstrategyplans", payload);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		console.log(response.error);
		return { status: false, msg: response.error.message };
	} else {
		return { status: false, msg: "Unknown error. Please try again." };
	}
}
//V4 - GET  STARTGEY ORDER HISTORY
export async function GetStrategyOrderHistory(payload) {
	const response = await makeApiRequest("/brokerpanelusers/strategies/getstrategyorderhistory", payload);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		console.log(response.error);
		return { status: false, msg: response.error.message };
	} else {
		return { status: false, msg: "Unknown error. Please try again." };
	}
}
// V4 - GET  MY STRATEGY 
export async function GetSubscribedStrategy() {
	const response = await makeGetApiRequest("/brokerpanelusers/strategies/getsubscribedstrategies");
	if (response.data) {
		return response;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
// V4 - SUBSCRIBED STRATEGY
export async function SubscribedStrategy(payload) {
	const response = await makeApiRequest("/brokerpanelusers/strategies/subscribestrategy", payload);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		console.log(response.error);
		return { status: false, msg: response.error.message };
	} else {
		return { status: false, msg: "Unknown error. Please try again." };
	}
}
// V4 - RENEW STRATEGY SUBSCRIPTION
export async function RenewStrategySubscription(payload) {
	const response = await makeApiRequest("/brokerpanelusers/strategies/renewstrategysubscription", payload);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		console.log(response.error);
		return { status: false, msg: response.error.message };
	} else {
		return { status: false, msg: "Unknown error. Please try again." };
	}
}
// V4 - UPDATE STARTEGY TARDING STATUS 
export async function UpdateStrategyTradingStatus(payload) {
	const response = await makeApiRequest("/users/groups/updatechildtradingflag", payload);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		console.log(response.error);
		return { status: false, msg: response.error.message };
	} else {
		return { status: false, msg: "Unknown error. Please try again." };
	}
}
//V4 - UPDATE STRATEGY LOT SIZE
export async function UpdateStrategyLotSize(values) {
	const response = await makeApiRequest("/users/groups/updategroupbroker", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
// V4 - UPGRADE STREATEGY SUBSCRIPTION PRICING 
export async function UpgradeStrategySubscriptionPricing(payload) {
	const response = await makeApiRequest("/brokerpanelusers/strategies/upgradestrategysubscriptionpricing", payload);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		console.log(response.error);
		return { status: false, msg: response.error.message };
	} else {
		return { status: false, msg: "Unknown error. Please try again." };
	}
}


// V4 -  UPGRADE STRATEGY SUBSCRIPTION 
export async function UpgradeStrategySubscription(payload) {
	const response = await makeApiRequest("/brokerpanelusers/strategies/upgradestrategysubscription", payload);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		console.log(response.error);
		return { status: false, msg: response.error.message };
	} else {
		return { status: false, msg: "Unknown error. Please try again." };
	}
}
// V4 -  GET STRATEGY POSITION  HISTORY
export async function GetStrategyPositionHistory(payload) {
	const response = await makeApiRequest("/brokerpanelusers/strategies/getstrategypositionhistory", payload);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		console.log(response.error);
		return { status: false, msg: response.error.message };
	} else {
		return { status: false, msg: "Unknown error. Please try again." };
	}
}
//--------------------------------------------------DEMAT ------------------------------
// V4 -GET AVAILABLE BROKER
export async function GetAvailableBrokers() {
	const response = await makeGetApiRequest("/users/broker/getavailablebrokers");
	if (response.data) {
		return response;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
// V4 -GET AVAILABLE IPS
export async function GetAvailableIps() {
	const response = await makeGetApiRequest("/users/ips/getavailableips");
	if (response) {
		return response;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}


// V4 - GET BROKER INFO 
export async function GetBrokerInfo(values) {
	const response = await makeApiRequest("/users/broker/getbrokerinfo", values);

	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
// V4 -CONNECT BROKER
export async function ConnectBroker(values) {
	const response = await makeApiRequest("/users/broker/connectbroker", values);

	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
// V4 - DIRECT PLACE OERDER
export async function DirectPlaceOrder(values) {
	const response = await makeApiRequest("/users/broker/direct/placeorder", values);

	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
// V4 - GET LTP 
export async function GetLTP(script_id) {
	const response = await makeApiRequest("/scripts/getltp", { script_id: script_id });
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
// V4 - SEARCH SCRIPTS
export async function SearchScriptByType(type, symbol,) {
	const response = await makeApiRequest("/scripts/searchscriptsbytype", { type, symbol });
	if (response.result) {
		return response.result;
	} else if (response.error) {
		console.log(response.error);
		return { status: false, msg: response.error.message };
	} else {
		return { status: false, msg: "Unknown error. Please try again." };
	}
}

//V4- UPDATE BROIKER TRADING FLAG
export async function UpdateBrokerTradingStatus(values) {
	const response = await makeApiRequest("/users/broker/updatebrokertradingflag", values);

	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}

// V4 - REFRESH BROKER 
export async function RefreshBroker(values) {
	const response = await makeApiRequest("/users/broker/refresh", values);

	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
//V4- REMOVE BROKER
export async function RemoveBroker(values) {
	const response = await makeApiRequest("/users/broker/removebroker", values);

	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}

//V4 - RECONNECT BROKER
export async function ReconnectBroker(values) {
	const response = await makeApiRequest("/users/broker/reconnect", values);

	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
//V4 - UPDATE BROEKR IP CONNECTION
export async function UpdateBrokerIpConnection(values) {
	const response = await makeApiRequest("/users/broker/setunsetip", values);

	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
// V4 -DIRECT ORDER SQUARE OFF 
export async function BrokerOrderSquareOff(values) {
	const response = await makeApiRequest("/users/broker/direct/squareoff", values);

	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}

// V4 - DIRECT ORDER SQUARE OFF All
export async function BrokerOrderSquareOffAll(values) {
	const response = await makeApiRequest("/users/broker/direct/squareoffall", values);

	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}

// V4 - UPDATE DIRECT ORDER
export async function UpdateDirectOrder(values) {
	const response = await makeApiRequest("/users/broker/direct/updateorder", values);

	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
//V4 -UPDATE BROKRT ORDER
export async function UpdateBrokerOrder(values) {
	const response = await makeApiRequest("/users/broker/direct/updatebrokerorder", values);

	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}

// V4 - UPDATE BROKER AUTO RENEW STATUS
export async function UpdateBrokerAutoRenewStatus(values) {
	const response = await makeApiRequest("/users/broker/updateautorenewflag", values);

	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
//V4 -UPDATE BROKER SUBSCRIPTION
export async function UpdateBrokerSubscription(values) {
	const response = await makeApiRequest("/users/broker/updatebrokersubscription", values);

	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
//V4 - PURCHASE IPS
export async function PurchaseStaticIp(payload) {
	const response = await makeApiRequest("/users/ips/purchasestaticip", payload);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		console.log(response.error);
		return { status: false, msg: response.error.message };
	} else {
		return { status: false, msg: "Unknown error. Please try again." };
	}
}

// V4 - GET STATIC IPS 
export async function GetStaticIP() {
	const response = await makeGetApiRequest("/users/ips/getstaticips");
	if (response.data) {
		return response;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
//V4 - UPDATE STATIC IP AUTO RENEW STATUS
export async function UpdateStaticIpAutoRenewStatus(payload) {
	const response = await makeApiRequest("/users/ips/updatestaticip", payload);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		console.log(response.error);
		return { status: false, msg: response.error.message };
	} else {
		return { status: false, msg: "Unknown error. Please try again." };
	}
}
//V4 - DELETE STATIC IP
export async function DeleteStaticIp(payload) {
	const response = await makeApiRequest("/users/ips/removestaticip", payload);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		console.log(response.error);
		return { status: false, msg: response.error.message };
	} else {
		return { status: false, msg: "Unknown error. Please try again." };
	}
}
//---------------------------------------------------REFERRAL ----------------------------

// V4 - GET REFERRAL 
export async function GetReferral() {
	const response = await makeGetApiRequest("/brokerpanelusers/getreferraldata");
	if (response.data) {
		return response;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
// V4 - GET REFERRAL EARNINGS
export async function GetReferralEarnings(payload) {
	const response = await makeApiRequest("/brokerpanelusers/getreferralearnings", payload);

	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
//--------------------------------------------------CONFIGS ----------------------------

// V4 - GET CONFIGS 
export async function GetConfigs() {
	const response = await makeGetApiRequest("/brokerpanelusers/getconfigs");
	if (response.data) {
		return response;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
//-----------------------------------------------ORDER HISTORY -------------------------

// V4 - GET ORDER HISTORY 
export async function GetOrderHistory(values) {
	const response = await makeApiRequest("/brokerpanelusers/getorderhistory", values);

	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
//---------------------------------------------------------DASHBAORD ------------------------

// V4 - GET DASHBOARD 
export async function GetDashbaord() {
	const response = await makeGetApiRequest("/brokerpanelusers/dashboard");
	if (response.data) {
		return response;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
//-------------------------------------------------------------------JSON BRIDGE-------------------------------------
//V4  - ADD JSON BRIDGE
export async function AddJsonBridge(values) {
	const response = await makeApiRequest("/users/jsonbridge/addjsonbridge", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}

// V4- GET JSON BRIDGE 
export async function GetJsonBridge() {
	const response = await makeGetApiRequest("/users/jsonbridge/getjsonbridges");
	if (response.data) {
		return response;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
//V4 - UPDATE JSON BRIDGE NAME 
export async function UpdateJsonBridgeName(values) {
	const response = await makeApiRequest("/users/jsonbridge/updatejsonbridgename", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
//V4  -  Connect Json Bridge 
export async function ConnectJsonBridge(values) {
	const response = await makeApiRequest("/users/jsonbridge/connectjsonbridge", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
//V4  -  Disconnect Json Bridge 
export async function DisconnectJsonBridge(values) {
	const response = await makeApiRequest("/users/jsonbridge/disconnectjsonbridge", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
//V4 - UPDATE JSON BRIDE TRADING FLAG
export async function UpdateJsonBridgeTradingFlag(values) {
	const response = await makeApiRequest("/users/jsonbridge/updatejsonbridgetradingflag", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
//V4 - REGENERATE JSON BRIDGE KEY 
export async function RegenerateJsonBridgeKey(values) {
	const response = await makeApiRequest("/users/jsonbridge/regeneratejsonbridgekey", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
//V4 - Delete Json Bridge 
export async function DeleteJsonBridge(values) {
	const response = await makeApiRequest("/users/jsonbridge/deletejsonbridge", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}

//V4 - GET JSON BRIDGE BY ID 
export async function GetJsonBridgeById(values) {
	const response = await makeApiRequest("/users/jsonbridge/getjsonbridgebyid", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
//V4 - JSON BRIDGE WEBHOOK SIMULATION
export async function JsonBridgeWebHookSimulation(json_bridge_id, json_bridge_key, payload) {
	const response = await makeApiRequest(`/users/jsonbridge/webhook/${json_bridge_id}/${json_bridge_key}`, payload, true);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		console.log(response.error);
		return { status: false, msg: response.error.message };
	} else {
		return { status: false, msg: "Unknown error. Please try again." };
	}
}
//V4 - JSON BRIDGE SEARCH SCRIPT 
export async function JsonBridgeSearchScript(payload) {
	const response = await makeApiRequest("/users/jsonbridge/searchscript", payload);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		console.log(response.error);
		return { status: false, msg: response.error.message };
	} else {
		return { status: false, msg: "Unknown error. Please try again." };
	}
}
// V4 - EXIT All ORDER GROUP PPOSITION 
export async function ExitAllOrderGroupPosition(values) {
	const response = await makeApiRequest("/ordermanager/exitallposition", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
// V4 - CANCEL All ORDER GROUP PPOSITION 
export async function CancelAllOrderGroupPosition(values) {
	const response = await makeApiRequest("/ordermanager/cancelallposition", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
// V4 - DELETE ALL POSITION 
export async function DeleteAllPosition(values) {
	const response = await makeApiRequest("/ordermanager/deleteallposition", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
// V4 - Enter All ORDER GROUP PPOSITION 
export async function EnterAllOrderGroupPosition(values) {
	const response = await makeApiRequest("/ordermanager/enterallposition", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}

// V4 - EDIT ORDER GROUP
export async function EditOrderGroup(values) {
	const response = await makeApiRequest("/ordermanager/editordergroup", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
// V4 - ADD POSITION IN ORDER GROUP
export async function AddOrderGroupPosition(values) {
	const response = await makeApiRequest("/ordermanager/addposition", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
// V4 - UPDATE POSITION IN ORDER GROUP
export async function UpdateOrderGroupPosition(values) {
	const response = await makeApiRequest("/ordermanager/editposition", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
// V4 - EXIT ORDER GROUP PPOSITION 
export async function ExitOrderGroupPosition(values) {
	const response = await makeApiRequest("/ordermanager/exitposition", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
// V4 - MARK AS ALREADY EXITED POSITION IN ORDER GROUP
export async function MarkAsAlreadyExitedPosition(values) {
	const response = await makeApiRequest("/ordermanager/markasexitedposition", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
// V4 - CANCEL ORDER GROUP PPOSITION 
export async function CancelOrderGroupPosition(values) {
	const response = await makeApiRequest("/ordermanager/cancelposition", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
// V4 - ENTER ORDER GROUP PPOSITION 
export async function EnterOrderGroupPosition(values) {
	const response = await makeApiRequest("/ordermanager/enterposition", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
// V4 - DELETE ORDER GROUP PPOSITION 
export async function DeleteOrderGroupPosition(values) {
	const response = await makeApiRequest("/ordermanager/deleteposition", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
//V4 - GET JSON  BRIDGE ORDER MANAGER DATA 
export async function GetJsonBridgeOrderManager(values) {
	const response = await makeApiRequest("/users/jsonbridge/getjsonordermanager", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}

//V4 - GET ORDER GROUPS
export async function GetOrderGroups() {
	const response = await makeGetApiRequest("/ordermanager/getordergroups");
	if (response.data) {
		return response;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
// V4 - ADD ORDER GROUP
export async function AddOrderGroup(values) {
	const response = await makeApiRequest("/ordermanager/addordergroup", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
// V4 - DELETE ORDER GROUP  
export async function DeleteOrderGroup(values) {
	const response = await makeApiRequest("/ordermanager/deleteordergroup", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}

// V4 - GET MY BROKER  
export async function GetMyBroker() {
	const response = await makeGetApiRequest("/users/broker/getmybroker");
	if (response.data) {
		return response;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
//------------------------------------------------------------------CUSTOM BRIDGE ------------------------------------
// V4- GET USER BRIDGE 
export async function GetUserBridge() {
	const response = await makeGetApiRequest("/users/bridge/getuserbridge");
	if (response.data) {
		return response;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
//V4  - GET USER BRIDGE BY ID
export async function GetUserBridgeById(values) {
	const response = await makeApiRequest("/users/bridge/getuserbridgebyid", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
//V4  - ADD USER BRIDGE
export async function AddUserBridge(values) {
	const response = await makeApiRequest("/users/bridge/adduserbridge", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
//V4 - UPDATE BRIDE TRADING FLAG
export async function UpdateBridgeTradingFlag(values) {
	const response = await makeApiRequest("/users/bridge/updatebridgetradingflag", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
//V4 - USER BRIDGE CONNECTION 
export async function UserBridgeConnection(values) {
	const response = await makeApiRequest("/users/bridge/userbridgeconnection", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
//V4 - USER BRIDGE DISCONNECT 
export async function UserBridgeDisconnect(values) {
	const response = await makeApiRequest("/users/bridge/userbridgedisconnect", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}

//V4 - USER BRIDGE REMOVE 
export async function RemoveUserBridge(values) {
	const response = await makeApiRequest("/users/bridge/removeuserbridge", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
//V4 - CHANGE  BRIDGE KEY
export async function ChangeBridgeKey(values) {
	const response = await makeApiRequest("/users/bridge/resetbridgekey", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
//V4 - UPDATE STARTEGY NAME 
export async function UpdateStartegyName(values) {
	const response = await makeApiRequest("/users/bridge/updatebridgename", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
//V4 - PLACE STRATEGY BRIDGE  ORDER
export async function PlaceStrategyBridgeOrder(values) {
	const response = await makeApiRequest("/users/bridge/placebridgeorder", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
//V4 - GET BRIDGE TRIGGER 
export async function GetBridgeTriggers(values) {
	const response = await makeApiRequest("/users/bridge/getbridgetriggers", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}

//V4 - ADD BRIDGE TRIGGER 
export async function AddBridgeTrigger(values) {
	const response = await makeApiRequest("/users/bridge/addbridgetrigger", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
//V4 - UPDATE BRIDGE TRIGGER 
export async function UpdateBridgeTrigger(values) {
	const response = await makeApiRequest("/users/bridge/updatebridgetrigger", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
//V4 - REMOVE BRIDGE TRIGGER 
export async function DeleteBridgeTrigger(values) {
	const response = await makeApiRequest("/users/bridge/removebridgetrigger", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
//V4 - UPDATE TRIGGER PRIORITIES
export async function UpdateTriggerPriorities(values) {
	const response = await makeApiRequest("/users/bridge/updatetriggerspriorities", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
//V4 - SEARCH SCIPTS 
export async function searchScriptByExchange(exchange, base_name,) {
	const response = await makeApiRequest("/scripts/searchscriptsbyexchange", { exchange, base_name });
	if (response.result) {
		return response.result;
	} else if (response.error) {
		console.log(response.error);
		return { status: false, msg: response.error.message };
	} else {
		return { status: false, msg: "Unknown error. Please try again." };
	}
}
//V4 - GET STRATEGY BRIDGE POSITIONS
export async function GetStrategyBridgePositions(values) {
	const response = await makeApiRequest("/users/bridge/getbridgepositions", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
//V4 - Mark Custom bridge Position Closed 
export async function MarkCustomBridgePositionClosed(values) {
	const response = await makeApiRequest("/users/bridge/markbridgepositionasclosed", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
//V4 - GET STRATEGY BRIDGE SIGNALS
export async function GetStrategyBridgeSignals(values) {
	const response = await makeApiRequest("/users/bridge/getbridgesignals", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}

//------------------------------------------------------------------CHARTINK------------------------------------------------------

//V4 - GET CHARTINKS
export async function GetChartinks() {
	const response = await makeGetApiRequest("/users/chartink/getchartinks");
	if (response) {
		return response;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
//V4 - ADD CHARTINKS
export async function AddChartink(values) {
	const response = await makeApiRequest("/users/chartink/addchartink", values);

	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
//V4 - UPDATE  CHARTINKS
export async function UpdateChartink(values) {
	const response = await makeApiRequest("/users/chartink/updatechartink", values);

	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
//V4 - CONNECT CHARTINK
export async function ConnectChartink(values) {
	const response = await makeApiRequest("/users/chartink/connectchartink", values);

	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
//V4 - DISCONNECT CHARTINK
export async function DisconnectChartink(values) {
	const response = await makeApiRequest("/users/chartink/disconnectchartink", values);

	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
//V4 - UPDATE CHARTINK TARDING STATUS
export async function UpdateChartinkTradingStatus(values) {
	const response = await makeApiRequest("/users/chartink/updatechartinktradingflag", values);

	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
//V4 - UPDATE LISTED STOCKS STATUS
export async function UpdateListedStocks(values) {
	const response = await makeApiRequest("/users/chartink/placelistedstockflag", values);

	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
//V4 - REGENERATE CHARTINK KEY 
export async function RegenerateChartinkKey(values) {
	const response = await makeApiRequest("/users/chartink/regeneratechartinkkey", values);

	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
//V4 -DELETE CHARTINK
export async function DeleteChartink(values) {
	const response = await makeApiRequest("/users/chartink/deletechartink", values);

	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
//V4 - ADD CHARTINK STOCK
export async function AddChartinkStock(values) {
	const response = await makeApiRequest("/users/chartink/addchartinkstock", values);

	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}


//V4 -  UPDATE CHARTINK STOCK
export async function UpdateChartinkStock(values) {
	const response = await makeApiRequest("/users/chartink/updatechartinkstock", values);

	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
//V4 - DELETE  CHARTINK STOCK
export async function DeleteChartinkStock(values) {
	const response = await makeApiRequest("/users/chartink/deletechartinkstock", values);

	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
//V4 - SEARCH SCIPTS FOR CHARTINK
export async function SearchScriptForChartink(exchange, base_name,) {
	const response = await makeApiRequest("/scripts/searchscriptsforchartink", { exchange, base_name });
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
//V4 - GET CHARTINK BY ID 
export async function GetChartinkById(values) {
	const response = await makeApiRequest("/users/chartink/getchartinkbyid", values);

	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
//V4 - CHARTINK WEBHOOK SIMULATION 
export async function ChartinkWebHookSimulation(chartink_id, chartink_key, payload) {
	const response = await makeApiRequest(`/users/chartink/webhook/${chartink_id}/${chartink_key}`, payload, true);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		console.log(response.error);
		return { status: false, msg: response.error.message };
	} else {
		return { status: false, msg: "Unknown error. Please try again." };
	}
}
//V4 - GET CHARTINK ORDER MANAGER 
export async function GetChartInkOrderManager(values) {
	const response = await makeApiRequest("/users/chartink/getchartinkordermanager", values);

	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
//------------------------------------------------------------------CHARTINK------------------------------------------------------
//V4 - GET TOOL SUBSCRIPTION 
export async function GetToolSubscription() {
	const response = await makeGetApiRequest("/brokerpanelusers/tools/gettoolsubscriptions");
	if (response) {
		return response;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
//V4 - PURCHASE TOOL SUBSCRIPTION 
export async function PurchaseToolSubscription(values) {
	const response = await makeApiRequest("/brokerpanelusers/tools/purchasetoolsubscription", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
//V4 - RENEW TOOL SUBSCRIPTION 
export async function RenewToolSubscription(values) {
	const response = await makeApiRequest("/brokerpanelusers/tools/renewtoolsubscription", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
//V4 - UPDATE AUTO RENEW 
export async function UpdateToolsAutoRenew(values) {
	const response = await makeApiRequest("/brokerpanelusers/tools/updateautorenew", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
//-------------------------------------- TELEGRAM BOAT   API CALL ---------------------------------------

//V4 - GET TELEGRAM BOT
export async function GetTelegramBot() {
	const response = await makeGetApiRequest("/brokerpanelusers/telegram/gettelegrambot");
	if (response) {
		return response;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
//V4 - ADD TELEGRAM BOT 
export async function AddTelegramBot(values) {
	const response = await makeApiRequest("/brokerpanelusers/telegram/addtelegrambot", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
//V4 -UPDATE  TELEGRAM BOT 
export async function UpdateTelegramBot(values) {
	const response = await makeApiRequest("/brokerpanelusers/telegram/updatetelegrambot", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
//V4 -DELETE  TELEGRAM BOT 
export async function DeleteTelegramBot(values) {
	const response = await makeApiRequest("/brokerpanelusers/telegram/removetelegrambot", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
//V4 ADD TELEGRAM CHANNEL
export async function AddTelegramChannel(values) {
	const response = await makeApiRequest("/brokerpanelusers/telegram/addtelegramchatconfig", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
//V4 - UPDATE  TELEGRAM CHANNEL
export async function UpdateTelegramChannel(values) {
	const response = await makeApiRequest("/brokerpanelusers/telegram/updatetelegramchatconfig", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
//V4 -DELETE  TELEGRAM CHANNEL
export async function DeleteTelegramChannel(values) {
	const response = await makeApiRequest("/brokerpanelusers/telegram/removetelegramchatconfig", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
//V4 - SEND TELEGRAM MESSAGE 
export async function SendTelegramMessage(values) {
	const response = await makeApiRequest("/brokerpanelusers/telegram/sendtgmessage", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
//ATTACH TELEGRAM TO SUBSCRIPTION 
export async function AttachTelegramToSubscription(values) {
	const response = await makeApiRequest("/brokerpanelusers/strategies/attachtelegramtosubscription", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
//REMOVE TELEGRAM TO SUBSCRIPTION 
export async function RemoveTelegramFromSubscription(values) {
	const response = await makeApiRequest("/brokerpanelusers/strategies/removetelegramfromsubscription", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
//V4 -  GET TELEGRAM CHANNEL
export async function GetTelegramChannel() {
	const response = await makeGetApiRequest("/brokerpanelusers/telegram/gettelegramchats");
	if (response) {
		return response;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
